import { ApiError } from '@/api/client'

/**
 * Translate a server error from POST /apply or /reject into a user-facing
 * toast. 429 / 409 / 422 each need a different mental model:
 *   - 429: backend (or upstream LLM provider) is rate-limited; ask the user
 *     to retry rather than letting them think the suggestion is broken.
 *   - 409: the action's no longer applicable (stale field, already applied,
 *     already rejected) — refreshing is the right move.
 *   - 422: validation failure — surface the backend's detail since it's the
 *     authoritative reason (e.g. "field … not found").
 */
export function formatActionError(
  err: unknown,
  verb: 'Accept' | 'Reject',
): string {
  if (err instanceof ApiError) {
    if (err.status === 429) {
      return 'The AI service is rate-limited right now. Please wait a moment and try again.'
    }
    if (err.status === 409) {
      return `${verb} failed: this suggestion is no longer current. Refresh and try again.`
    }
    if (err.status === 422) {
      return `${verb} failed: ${err.message || 'validation error'}`
    }
    return `${verb} failed: ${err.message || 'unknown error'}`
  }
  if (err instanceof Error) {
    return `${verb} failed: ${err.message}`
  }
  return `${verb} failed`
}
